import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { format } from "date-fns"
import { IDataNascimentoFilter } from "../../../../../../../application/models";
// Icon
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const RecorteDataNascimentoFilterPreview = (props: {
    dataNascimentoFilter?: IDataNascimentoFilter
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Data de Nascimento
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.dataNascimentoFilter && props.dataNascimentoFilter.min &&
                                <Chip
                                    key={0}
                                    icon={<CalendarMonthIcon />}
                                    label={`de: ${format(new Date(props.dataNascimentoFilter.min), 'dd/MM/yyyy')}`}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            }
                            {props.dataNascimentoFilter && props.dataNascimentoFilter.max &&
                                <Chip
                                    key={1}
                                    icon={<CalendarMonthIcon />}
                                    label={`até: ${format(new Date(props.dataNascimentoFilter.max), 'dd/MM/yyyy')}`}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            }
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}